module.exports = __webpack_public_path__ + "media/images/footer-logo-c8b7a44265e3c9f09c6cecd17fab6ce7.png";